import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import { InitPage } from 'src/helper/tool'

export default class {
  @observable data = {
    language: 'en',
    lang: {},
    langAll: {}
  }

  @action async GetLang(query) {
    let lang = {
      en: {
        lag: 'English',
        lag1: 'English',
        lag2: 'Türkçe',
        lag3: ' بالعربية ',
        lag4: 'Português',
        lag5: 'indonésio',
        nav1: 'Recharge',
        nav2: 'About Us',
        nav3: 'Help Center',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'Online Chat',
        dt1: 'Chat with people from all over the world. You have multiple choices for room settings to have either public  or private conversations.',
        dt2T: 'Online Games',
        dt2: 'App provides a wide range of online mobile games for users. You can start games with high-quality real time voice chat, to enjoy the fun and excitedness of mobile games with friends online.',
        dt3T: 'Online Video',
        dt3: 'App provides an online space for uses to watch video with people even though they are physically distancing. It can either be a private space to enjoy videos or a public place to enjoy video with friends.',
        about1: 'Terms of Use',
        about2: 'Recharge',
        about3: 'Social Media',
        about4: 'Privacy Policy',
        about5: 'About Us',
        about6: 'Help Center',
        about7: 'Contact Us',
        about8:
          'App is a mobile application for people to enjoy real-time voice chat of high quality. Yayya is simple to use, fun, and it includes diverse groups of users from all lover the world. It enables users to create multiple types of rooms, voice chat rooms, rooms to watch videos and rooms to electronic games. It helps every one to find people and stuff that they are interested.',
        about9: 'Email: service@yayya.live',
        terms: 'Terms of Use'
      },
      tr: {
        lag: 'Türkçe',
        lag1: 'English',
        lag2: 'Türkçe',
        lag3: ' بالعربية ',
        lag4: 'Português',
        lag5: 'indonésio',
        nav1: 'Yeniden Yükle',
        nav2: 'Hakkımızda',
        nav3: 'Yardım Merkezi',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content:
          'Uygulamayı kullanarak, basit ve güvenilir bir şekilde dünyadaki insanlarla konuşabilir ve arkadaş edinebilirsiniz.',
        dt1T: 'Çevrimiçi Sohbet',
        dt1: 'Dünyanın dört bir yanından insanlarla sohbet edin. Kamuya açık veya özel sohbetler için oda ayarlarıyla birden fazla seçeneğiniz vardır.',
        dt2T: 'Çevrimiçi Oyunlar',
        dt2: 'Uygulama, kullanıcılar için geniş bir çevrimiçi mobil oyun yelpazesi sunmaktadır. Yüksek kaliteli gerçek zamanlı sesli sohbetle oyunlara başlayabilir, arkadaşlarınızla çevrimiçi olarak mobil oyunların eğlencesini ve heyecanını yaşayabilirsiniz.',
        dt3T: 'Çevrimiçi Video',
        dt3: 'Uygulama, kullanıcıların fiziksel mesafeye rağmen başkalarıyla video izlemesi için çevrimiçi bir alan sağlar. Bu, videoları tek başına izlemek için özel bir alan veya arkadaşlarla birlikte video izlemek için kamusal bir alan olabilir.',
        about1: 'Kullanım Şartları',
        about2: 'Yeniden Yükle',
        about3: 'Sosyal Medya',
        about4: 'Gizlilik Politikası',
        about5: 'Hakkımızda',
        about6: 'Yardım Merkezi',
        about7: 'Bize Ulaşın',
        about8:
          'Uygulama, insanların yüksek kaliteli gerçek zamanlı sesli sohbetin keyfini çıkarmalarını sağlayan bir mobil uygulamadır. Yayya, kullanımı kolay, eğlencelidir ve dünya çapında çeşitli kullanıcı gruplarını içermektedir. Kullanıcıların, sesli sohbet odaları, video izleme odaları ve elektronik oyun odaları gibi çeşitli oda türleri oluşturmasına olanak tanır. Herkesin ilgi duyduğu insanları ve şeyleri bulmasına yardımcı olur.',
        about9: 'Email: service@yayya.live',
        terms: 'Kullanım Şartları'
      },
      ar: {
        lag: ' بالعربية ',
        lag1: 'English',
        lag2: 'Türkçe',
        lag3: ' بالعربية ',
        lag4: 'Português',
        lag5: 'indonésio',
        nav1: '',
        nav2: 'عنا',
        nav3: '',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'دردشة على الانترنت',
        dt1: 'دردشة - .يمكنك اختيار إعدادات غرفة متعددة لإجراء محادثات عامة أو خاصة .',
        dt2T: 'العاب اون لاين',
        dt2: 'App يوفر للمستخدمين مجموعة واسعة من الألعاب عبر الإنترنت للهواتف النقالة .يمكنك البدء في اللعب من خلال الدردشة الصوتية عالية الجودة في الوقت الحقيقي ، والتمتع متعة وإثارة من العاب الجوال مع الأصدقاء على الانترنت .',
        dt3T: 'فيديو اون لاين',
        dt3: 'غرف الدردشة توفر مساحة على الانترنت للمستخدمين لمشاهدة الفيديو مع الناس ، حتى لو كانوا جسديا على مسافة .أنها يمكن أن تكون مساحة خاصة للاستمتاع الفيديو ، يمكن أن تكون أيضا مكان عام للاستمتاع الفيديو مع الأصدقاء .',
        about1: '',
        about2: '',
        about3: '',
        about4: '',
        about5: 'عنا',
        about6: '',
        about7: 'اتصل بنا',
        about8:
          'App هو تطبيق المحمول التي يمكن للناس التمتع عالية الجودة في الوقت الحقيقي دردشة صوتية .App بسيطة ومثيرة للاهتمام للاستخدام ، ويشمل مجموعات مختلفة من المستخدمين من جميع أنحاء العالم .فإنه يمكن للمستخدمين إنشاء أنواع مختلفة من غرف الدردشة ، غرف الدردشة الصوتية ، ومشاهدة الفيديو وغرف الدردشة والألعاب الإلكترونية غرف الدردشة .فهو يساعد الجميع على العثور على الناس والأشياء التي تهمهم .',
        about9: 'Email: service@yayya.live',
        terms: 'Kullanım Şartları'
      },
      pt: {
        lag: 'Português',
        lag1: 'English',
        lag2: 'Türkçe',
        lag3: ' بالعربية ',
        lag4: 'Português',
        lag5: 'indonésio',
        nav1: 'Recarregar',
        nav2: 'Sobre nós',
        nav3: 'Central de Ajuda',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'Bate-papo Online',
        dt1: 'Converse com pessoas de todo o mundo. Você tem várias opções de configurações de sala para conversas públicas ou privadas.',
        dt2T: 'Jogos Online',
        dt2: 'O App oferece uma ampla variedade de jogos móveis online para os usuários. Você pode iniciar jogos com bate-papo por voz em tempo real de alta qualidade, para desfrutar da diversão e empolgação dos jogos móveis com amigos online.',
        dt3T: 'Vídeo Online',
        dt3: 'O App oferece um espaço online para os usuários assistirem a vídeos com outras pessoas, mesmo estando fisicamente distantes. Pode ser um espaço privado para curtir vídeos ou um local público para assistir vídeos com amigos.',
        about1: 'Termos de Uso',
        about2: 'Recarregar',
        about3: 'Mídias Sociais',
        about4: 'Política de Privacidade',
        about5: 'Sobre nós',
        about6: 'Central de Ajuda',
        about7: 'Entre em Contato',
        about8:
          'O App é um aplicativo móvel para pessoas desfrutarem de bate-papo por voz em tempo real de alta qualidade. Yayya é simples de usar, divertido, e inclui grupos diversos de usuários de todo o mundo. Ele permite que os usuários criem vários tipos de salas, como salas de bate-papo por voz, salas para assistir vídeos e salas para jogos eletrônicos. Ele ajuda todos a encontrarem pessoas e coisas que estão interessados.',
        about9: 'Email: service@yayya.live',
        terms: 'Termos de Uso'
      },
      id: {
        lag: 'indonésio',
        lag1: 'English',
        lag2: 'Türkçe',
        lag3: ' بالعربية ',
        lag4: 'Português',
        lag5: 'indonésio',
        nav1: 'Isi Ulang',
        nav2: 'Tentang Kami',
        nav3: 'Pusat Bantuan',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'Obrolan Online',
        dt1: 'Berbicara dengan orang dari seluruh dunia. Anda memiliki beberapa pilihan pengaturan ruang untuk percakapan publik atau pribadi.',
        dt2T: 'Permainan Online',
        dt2: 'Aplikasi menyediakan berbagai permainan mobile online untuk pengguna. Anda dapat memulai permainan dengan obrolan suara waktu nyata berkualitas tinggi, untuk menikmati keseruan dan kegembiraan permainan mobile bersama teman secara online.',
        dt3T: 'Video Online',
        dt3: 'Aplikasi menyediakan ruang online untuk pengguna menonton video dengan orang lain meskipun mereka terpisah jarak. Ini bisa menjadi ruang pribadi untuk menikmati video atau tempat umum untuk menikmati video bersama teman.',
        about1: 'Ketentuan Penggunaan',
        about2: 'Isi Ulang',
        about3: 'Media Sosial',
        about4: 'Kebijakan Privasi',
        about5: 'Tentang Kami',
        about6: 'Pusat Bantuan',
        about7: 'Hubungi Kami',
        about8:
          'Aplikasi adalah aplikasi seluler untuk orang-orang menikmati obrolan suara waktu nyata berkualitas tinggi. Yayya mudah digunakan, menyenangkan, dan mencakup kelompok pengguna yang beragam dari seluruh dunia. Ini memungkinkan pengguna untuk membuat berbagai jenis ruangan, seperti ruangan obrolan suara, ruangan untuk menonton video, dan ruangan untuk permainan elektronik. Ini membantu setiap orang menemukan orang dan hal-hal yang mereka minati.',
        about9: 'Email: service@yayya.live',
        terms: 'Ketentuan Penggunaan'
      },
      ru: {
        lag: 'Русский',
        lag1: 'Русский',
        lag2: 'Туркский',
        lag3: 'Арабский',
        lag4: 'Португальский',
        lag5: 'Индонезийский',
        nav1: 'Пополнение баланса',
        nav2: 'О нас',
        nav3: 'Центра помощи',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'Онлайн-чат',
        dt1: 'Общайтесь с людьми со всего мира. У вас есть несколько вариантов настроек комнат для публичных или личных бесед.',
        dt2T: 'Онлайн-игры',
        dt2: 'Приложение предлагает широкий спектр онлайн-мобильных игр для пользователей. Вы можете начинать игры с качественным голосовым чатом в реальном времени, чтобы наслаждаться весельем и возбуждением мобильных игр с друзьями онлайн.',
        dt3T: 'Онлайн-видео',
        dt3: 'Приложение предоставляет онлайн-пространство для просмотра видео с людьми, даже если вы находитесь в физическом удалении. Это может быть либо частное пространство для просмотра видео, либо общее место для просмотра видео с друзьями.',
        about1: 'Условия использования',
        about2: 'Пополнение баланса',
        about3: 'Социальные сети',
        about4: 'Политика конфиденциальности',
        about5: 'О нас',
        about6: 'Центра помощи',
        about7: 'Свяжитесь с нами',
        about8:
          'Приложение — это мобильное приложение, позволяющее людям наслаждаться качественным голосовым чатом в реальном времени. Hobby легко в использовании, забавно и включает разнообразные группы пользователей со всего мира. Приложение позволяет пользователям создавать разные типы комнат: комнаты для голосового чата, комнаты для просмотра видео и комнаты для электронных игр. Оно помогает каждому найти людей и вещи, в которых они заинтересованы.',
        about9: 'Email: service@yayya.live',
        terms: 'Условия использования'
      },
      uz: {
        lag: 'Oʻzbek',
        lag1: 'Oʻzbek',
        lag2: 'Turk',
        lag3: 'Arab',
        lag4: 'Portugall',
        lag5: 'Indonoz',
        nav1: 'Balansni toʻldiring',
        nav2: 'Biz haqimizda',
        nav3: 'Yordam markazi',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'Onlayn suhbat',
        dt1: 'Dunyo boyligʻidagi barcha odamlar bilan suhbat qiling. Sizga kamron sozlamalari boʻyicha bir nechta variantlar bor, ya nuqtali, yoki maxsus suhbat olib borishingiz mumkin.',
        dt2T: 'Onlayn oʻyinlar',
        dt2: 'App foydalanuvchilar uchun keng qoʻllab-quvvatlanadigan onlayn mobil oʻyinlarni taqdim etadi. Siz yuqori sifatli vaqt-sifatdagi ovozli suhbat bilan oʻyin boshlashingiz mumkin, shunda siz doʻstlaringiz bilan onlayn mobil oʻyinlar bilan zabavnolarni va hayran boʻlishingiz mumkin.',
        dt3T: 'Onlayn video',
        dt3: 'App foydalanuvchilarga jismoniy masofada boʻlsa ham boshqalar bilan video koʻra olish uchun onlayn joy taqdim etadi. Bu hisoblanadi ya shaxsiy joy oʻrinda videolarni tanoshlash uchun, yoki doʻstlaringiz bilan videolarni tanoshlash uchun umumiy joy.',
        about1: 'Foydalanish shartlari',
        about2: 'Balansni toʻldiring',
        about3: 'Sosial tarmoq',
        about4: 'Maxfiylik siyosati',
        about5: 'Biz haqimizda',
        about6: 'Yordam markazi',
        about7: 'Biz bilan bogʻlaning',
        about8:
          'App dunyo boyligʻidagi barcha odamlar bilan yuqori sifatli vaqt-sifatdagi ovozli suhbatni tanoshlash uchun moʻljal boʻlgan mobil ilovalar. Hobby foydalanishni oson qiladi, zabavnoli va uning ichida dunyo boyligʻidagi barcha odamlardan iborat mazhurlashgan foydalanuvchilarning guruhlari. App foydalanuvchilarga fariqli turdagi kamronlarni yaratish imkoniyatini beradi: ovozli suhbat kamronlari, video koʻra olish kamronlari va elektron oʻyin kamronlari. U har birini oʻz faqoratlarini topishga yordam beradi.',
        about9: 'Email: service@yayya.live',
        terms: 'Foydalanish shartlari'
      },
      fa: {
        lag: 'فارسی',
        lag1: 'فارسی',
        lag2: 'ترکی',
        lag3: 'عربی',
        lag4: 'پرتگالی',
        lag5: 'اندونیزی',
        nav1: 'شارژ',
        nav2: 'درباره ما',
        nav3: 'مرکز کمک',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'چت آنلاین',
        dt1: 'با افراد در سراسر جهان صحبت کنید. شما چندین گزینه برای تنظیمات اتاق دارید تا بتوانید صحبت عمومی یا خصوصی داشته باشید.',
        dt2T: 'بازی‌های آنلاین',
        dt2: 'اپلیکیشن مجموعه‌ای گسترده‌ای از بازی‌های موبایل آنلاین برای کاربران ارائه می‌دهد. شما می‌توانید با چت صوتی با کیفیت بالا در زمان واقعی بازی‌ها را شروع کنید تا مانند دوستان خود، متعه و خوشحالمانی بزاینگری از بازی‌های موبایل شوید.',
        dt3T: 'ویدئو آنلاین',
        dt3: 'اپلیکیشن فضای آنلاینی برای مشاهده ویدئو با افراد ارائه می‌دهد، حتی در صورت فاصله فیزیکی. این می‌تواند فضای شخصی باشد برای لذت‌بخشی از ویدئوها یا مکان عمومی برای لذت‌بخشی از ویدئوها با دوستان شوید.',
        about1: 'شرایط استفاده',
        about2: 'شارژ',
        about3: 'メディア اجتماعی',
        about4: 'سیاست حفظ خصوصی',
        about5: 'درباره ما',
        about6: 'مرکز کمک',
        about7: 'ارتباط با ما',
        about8:
          'اپلیکیشن یک اپلیکیشن موبایل برای افراد است که می‌توانند از چت صوتی با کیفیت بالا در زمان واقعی لذت ببرند. هابی به استفاده آسان، سرگرم‌کننده و شامل گروه‌های متنوعی از کاربران از سراسر جهان است. این اپلیکیشن اجازه می‌دهد که کاربران اتاق‌های مختلفی ایجاد کنند؛ اتاق‌های چت صوتی، اتاق‌های برای مشاهده ویدئو و اتاق‌های برای بازی‌های الکترونیکی. این کمک می‌کند که همه به دنبال افراد و چیزهایی که علاقه‌مند هستندند پیدا کنند.',
        about9: 'ایمیل: service@yayya.live',
        terms: 'شرایط استفاده'
      },
      ur: {
        lag: 'انگریزی',
        lag1: 'انگریزی',
        lag2: 'ترکی',
        lag3: 'عربی',
        lag4: 'پرتگالی',
        lag5: 'انڈونیشیائی',
        nav1: 'ریچارج',
        nav2: 'ہمارے بارے میں',
        nav3: 'ہیلپ سینٹر',
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content: '',
        dt1T: 'آن لائن چیٹ',
        dt1: 'دنیا بھر کے لوگوں سے بات کریں۔ آپ کے پاس کمرے کی ترتیبات کے لیے کئی اختیارات ہیں تاکہ عوامی یا نجی گفتگو کی جا سکے۔',
        dt2T: 'آن لائن گیمز',
        dt2: 'ایپ صارفین کے لیے آن لائن موبائل گیمز کی ایک وسیع رینج فراہم کرتی ہے۔ آپ اعلیٰ معیار کی ریئل ٹائم وائس چیٹ کے ساتھ گیمز شروع کر سکتے ہیں، تاکہ آن لائن دوستوں کے ساتھ موبائل گیمز کا لطف اٹھایا جا سکے۔',
        dt3T: 'آن لائن ویڈیو',
        dt3: 'ایپ صارفین کے لیے ایک آن لائن جگہ فراہم کرتی ہے جہاں وہ لوگوں کے ساتھ ویڈیو دیکھ سکتے ہیں چاہے وہ جسمانی طور پر دور ہی کیوں نہ ہوں۔ یہ یا تو ویڈیوز سے لطف اندوز ہونے کے لیے ایک نجی جگہ ہو سکتی ہے یا دوستوں کے ساتھ ویڈیو دیکھنے کے لیے ایک عوامی مقام۔',
        about1: 'استعمال کی شرائط',
        about2: 'ریچارج',
        about3: 'سوشل میڈیا',
        about4: 'رازداری کی پالیسی',
        about5: 'ہمارے بارے میں',
        about6: 'ہیلپ سینٹر',
        about7: 'ہم سے رابطہ کریں',
        about8: 'ایپ ایک موبائل ایپلیکیشن ہے جہاں لوگ اعلیٰ معیار کی ریئل ٹائم وائس چیٹ سے لطف اندوز ہو سکتے ہیں۔ Yayya استعمال میں آسان، مزیدار ہے، اور اس میں دنیا بھر کے متنوع صارفین شامل ہیں۔ یہ صارفین کو کمرے کی متعدد اقسام بنانے کی سہولت دیتا ہے، جیسے وائس چیٹ رومز، ویڈیو دیکھنے کے کمرے اور الیکٹرانک گیمز کھیلنے کے کمرے۔ یہ ہر کسی کو ان لوگوں اور چیزوں کو تلاش کرنے میں مدد کرتا ہے جن میں وہ دلچسپی رکھتے ہیں۔',
        about9: 'ای میل: service@yayya.live',
        terms: 'استعمال کی شرائط'
      }
    }
    if (this.data.language && this.data.language != 'en') {
      query.lang = query.language || this.data.language
    } else {
      query.lang = query.language
    }
    let { uid, language, langJson } = await InitPage(query, lang)
    this.data.language = language
    this.data.lang = langJson || lang.en
    this.data.langAll = lang
  }

  @action async setLang(la) {
    console.log('设置语言', la)
    this.data.language = la
    this.data.lang = this.data.langAll[la]
  }
}



// WEBPACK FOOTER //
// src/store/home/index.js